import axios from "axios";
import jwt_decode from "jwt-decode";
import Api from "../config";
import { Store } from "../states/store";
import { reset } from "../states/slices/authReducer";

// const Api = process.env.REACT_APP_BASE_URL;

class AuthService {
  async login(email: string, password: string) {
    const { data } = await Api.post(`/auth/login`, { email, password });

    return data;
  }

  logout() {
    Store.dispatch(reset());
    localStorage.removeItem("token");
  }

  getToken() {
    return localStorage.getItem("token");
  }

  decodeToken() {
    const token = this.getToken();
    if (token) {
      return jwt_decode(token);
    }
    return null;
  }

  isAuthenticated() {
    const token = this.getToken();
    return token !== null;
  }
}

export default new AuthService();
